/**
 * useViewAs Hook
 *
 * Reads the ?viewAs={agentId} query parameter from the URL.
 * Only returns a valid viewAsAgentId if the current user is an admin.
 * Used by AgentContext to load a target agent's data instead of the user's own.
 */

import { useSearchParams, useNavigate } from "react-router-dom";
import { useAdmin } from "@/hooks/useAdmin";

export function useViewAs() {
  const [searchParams] = useSearchParams();
  const { role, loading } = useAdmin();
  const navigate = useNavigate();

  const rawViewAs = searchParams.get("viewAs");

  // Only admin role can use viewAs (not sales, not account_manager)
  const isViewingAs = !loading && role === "admin" && !!rawViewAs;
  const viewAsAgentId = isViewingAs ? rawViewAs : null;

  const exitViewAs = () => {
    navigate("/admin/agents", { replace: true });
  };

  return { viewAsAgentId, isViewingAs, exitViewAs, loading };
}
